// helper/event_bus.js
import mitt from 'mitt'

const emitter = mitt()

// Keep both the modern names and Vue 2-style aliases
const EventBus = {
  // modern
  on: (type, handler) => emitter.on(type, handler),
  off: (type, handler) => emitter.off(type, handler),
  emit: (type, payload) => emitter.emit(type, payload),

  // Vue 2 aliases so existing code like EventBus.$emit(...) still works
  $on: (type, handler) => emitter.on(type, handler),
  $off: (type, handler) => emitter.off(type, handler),
  $emit: (type, payload) => emitter.emit(type, payload),

  // Optional: one-time listener
  once(type, handler) {
    const fn = (payload) => {
      emitter.off(type, fn)
      handler(payload)
    }
    emitter.on(type, fn)
  },
}

export default EventBus
